<template>
  <!-- 视频观看页面 -->
  <div class="video">
    <div class="top_fixed">
      <!-- 视频区域 -->
      <div class="videoContext">
        <!-- 群公告区域 -->
        <div class="notice-card-wrapper" :class="showNotice ? '' : 'hide-notice'">
          <div class="inner-container">
            <van-notice-bar left-icon="volume-o" :text="live.remark" background="none" color="yellow" />
          </div>
        </div>
        <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true"
          :options="playerOptions"></video-player>
      </div>
      <div class="info">
        <div>
          <img src="../../../assets/img/lumi.png" alt />
          <span>{{ live.liveName }}</span>
        </div>
        <div class="current">
          <span v-if="live.liveStatus === 1">观看人次：{{ current.total ? current.total : '-' }} / 在线人数：
            {{ current.times ? current.times : '-' }}</span>
          <span v-if="live.liveStatus === 2">观看人次：{{ total >= 1 ? total : live.liveAttr.lookNum }}</span>
          <!-- <p>{{ total }}</p> -->
        </div>
        <p class="col-red">
          直播时间：{{ live.liveStartTime }} 至 {{ live.liveEndTime }}
        </p>
      </div>
      <!-- 文本区域 -->
      <!-- 标题 -->
      <mt-navbar v-model="selected">
        <mt-tab-item id="score">向老师提问</mt-tab-item>
        <mt-tab-item id="comment">聊天</mt-tab-item>
        <mt-tab-item id="note">{{
          live.liveCrowdGroup ? '联系我们' : '直播详情'
        }}</mt-tab-item>
      </mt-navbar>
    </div>
    <div class="bottom_fixed">
      <!-- 内容 -->
      <mt-tab-container v-model="selected">
        <!-- 评论区 -->
        <mt-tab-container-item id="comment">
          <div class="questions-list">
            <div class="questions-list-item" v-for="(item, index) in commentLists" :key="index">
              <div class="questions-list-item-heading">
                <img :src="item.avatar
                    ? item.avatar
                    : require('../../../assets/img/timg.jpg')
                  " />
                <span class="questions-list-item-username">{{
                  item.nick
                }}</span>
              </div>
              <div class="questions-list-item-content">{{ item.content }}</div>
            </div>
            <div v-if="!commentNone" style="
                text-align: center;
                font-size: 12px;
                color: #666;
                margin-top: 10px;
              " @click="loadMoreComment">
              点击加载更多...
            </div>
            <div v-else style="
                text-align: center;
                font-size: 12px;
                color: #666;
                margin-top: 10px;
              ">
              暂无更多数据...
            </div>
          </div>
          <div v-if="live.liveStatus === 1 && selected === 'comment'" class="input_footer">
            <div class="noteBottom" style="width: 80%">
              <input v-model="comment" required="true" placeholder="请发表评论" id="textpanel" style="width: 90%" />
            </div>
            <button @click="addComments(comment)" class="comment-send-btn" :class="isliving ? 'disableClass' : ''"
              :disabled="isliving">
              发送
            </button>
          </div>
        </mt-tab-container-item>
        <!-- 提问区域 -->
        <mt-tab-container-item id="score">
          <div class="score">
            <!-- 提问列表展示区域 -->
            <div class="questions-list">
              <div class="questions-list-item" v-for="(item, index) in questList" :key="index">
                <div class="questions-list-item-heading">
                  <img :src="item.avatar
                      ? item.avatar
                      : require('../../../assets/img/timg.jpg')
                    " />
                  <span class="questions-list-item-username">{{
                    item.nick
                  }}</span>
                </div>
                <div class="questions-list-item-content">
                  {{ item.queContent }}
                </div>
              </div>
              <div v-if="!questionNone" style="
                  text-align: center;
                  font-size: 12px;
                  color: #666;
                  margin-top: 10px;
                " @click="loadMoreQuestion">
                点击加载更多...
              </div>
              <div v-else style="
                  text-align: center;
                  font-size: 12px;
                  color: #666;
                  margin-top: 10px;
                ">
                暂无更多数据...
              </div>
            </div>
            <div v-if="live.liveStatus === 1" class="input_footer">
              <div class="noteBottom" style="width: 80%">
                <a @click="getCerSpeciality">{{ teacher || '@讲师' }}</a>
                <!-- 提问讲师列表 -->
                <mt-popup v-model="cerSpecialityShow" position="bottom" popup-transition="popup-fade" fixed>
                  <div @click="askTeacher(teacher)" class="showPopup">完成</div>
                  <mt-picker :slots="dataSlots" :visibleItemCount="5" valueKey="name"
                    @change="onCerSpecialityChange"></mt-picker>
                </mt-popup>
                <input required="true" v-model="askText" style="width: 60%" placeholder="请写下您的问题" />
              </div>
              <button @click="addQuestion(askText)" class="comment-send-btn" :class="isliving ? 'disableClass' : ''"
                :disabled="isliving">
                提问
              </button>
            </div>
          </div>
        </mt-tab-container-item>
        <!-- 联系我们 -->
        <mt-tab-container-item id="note">
          <div class="timg" v-if="live.liveCrowdGroup">
            <img :src="live.liveCrowdGroup" />
          </div>
          <div v-else>
            <div class="columns">
              <img src="../../../assets/img/list1.png" />
              <span class="p-title">直播介绍</span>
              <p class="p-desc" v-html="live.liveDetail" v-clipboard:copy="live.liveDetail" v-clipboard:success="onCopy"
                v-clipboard:error="onError" @click="imageChgange($event)"></p>
            </div>
          </div>
        </mt-tab-container-item>
      </mt-tab-container>
    </div>
  </div>
</template>

<script>
let timer = null
import Base64 from 'base-64'
import ReconnectingWebSocket from 'reconnecting-websocket'
import { ImagePreview } from 'vant'
import CourseMeans from '../../../components/details/CourseMeans'
export default {
  // 离开当前页，断开websock
  beforeRouteLeave(to, form, next) {
    var node = document.getElementsByTagName('body')[0]
    if (node.classList.contains('van-overflow-hidden')) {
      this.$router.go(1)
      return
    }
    if (timer) {
      clearInterval(timer)
    }
    if (this.websock) {
      this.websock.close()
    }

    this.$refs.videoPlayer.player.reset()
    this.websock = null
    next()
  },
  components: { CourseMeans },
  data() {
    return {
      teacherSub: '',
      questList: [],
      commentLists: [],
      comment: '',
      teacherListShow: 'none',
      selected: 'score',
      commentText: '',
      askText: '',
      teacher: '',
      showNotice: true,
      teachers: [],
      live: {},
      playerOptions: {},
      websock: null,
      isAuth: false,
      userInfo: {},
      state: null,
      cerSpecialityShow: false,
      // 讲师选择
      dataSlots: [
        {
          flex: 1,
          values: [],
        },
      ],
      total: 0,
      tims: 0,
      tim: 0,
      // 人数
      current: {
        total: 0,
        times: 0,
      },
      isKeyword: false,
      isliving: true,
      liveId: '',
      mobile: '',
      commentIndex: 0,
      questionIndex: 0,
      commentNone: false,
      questionNone: false,
    }
  },
  computed: {
    text() {
      return {
        id: this.number,
        val: this.textArr[this.number],
      }
    },
  },
  destroyed() {
    if (timer) {
      clearInterval(timer)
    }
    if (this.websock) {
      this.websock.close()
    }

    this.$refs.videoPlayer.player.reset()
    this.websock = null
  },
  mounted() {
    window.getAndriodFn = this.getAndriodFn
    // this.getAndriodFn()
  },
  created() {
    const _this = this
    //广播消息隐藏
    setTimeout(function () {
      _this.$nextTick(() => {
        _this.showNotice = false
      })
    }, 300000)
  },
  methods: {
    onCopy(e) {
      this.$toast('复制成功！')
    },
    onError(e) {
      this.$toast('复制失败！')
    },
    // andriod调用后的逻辑判断
    getAndriodFn(data) {
      let _this = this
      let newData = eval('(' + data + ')')
      _this.liveId = newData.liveId

      _this.mobile = newData.mobile

      // _this.getLiveList(_this.liveId)
      _this.getUserInfo(newData.mobile)

      // 销毁获取评论
      // localStorage.removeItem('commentLists_' + _this.liveId)
      _this.getAllComments(newData.liveId)

      // 销毁获取提问
      // localStorage.removeItem('questList_' + _this.liveId)
      _this.getAllQuestions(newData.liveId)
    },
    // getAndriodFn() {
    //   let _this = this
    //   // let newData = eval('(' + data + ')')
    //   _this.liveId = 23
    //   _this.mobile = 13072953280

    //   _this.getLiveList(23)
    //   _this.getUserInfo(13072953280)

    //   // 销毁获取评论
    //   // localStorage.removeItem('commentLists_' + _this.liveId)
    //   _this.getAllComments(23)

    //   // 销毁获取提问
    //   // localStorage.removeItem('questList_' + _this.liveId)
    //   _this.getAllQuestions(23)
    // },

    imageChgange(e) {
      if (e.target.nodeName == 'IMG') {
        ImagePreview({
          images: [e.target.currentSrc], //e.target.currentSrc  当前图片src
          showIndex: false,
          loop: false,
          closeOnPopstate: true,
        })
      } else {
        return
      }
    },
    // 老师改变
    onCerSpecialityChange(picker, values) {
      if (values[0]) {
        this.teacherSub = '@' + values[0]
      }
      if (this.cerSpecialityShow) {
        if (values[0]) {
          this.teacher = '@' + values[0]
        }
      }
    },
    getCerSpeciality() {
      this.teacher = this.teacherSub
      this.cerSpecialityShow = true
    },
    getUserInfo(mobile) {
      this.$http({
        url: '/live/liveUsers/getUserDetail',
        method: 'get',
        params: { mobile: mobile },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.userInfo = data.user
          this.getLiveList(this.liveId)
        }
      })
    },
    //获取历史评论
    getAllComments(liveId) {
      this.$http({
        url: `/live/userLiveComments/getCommentsByPage`,
        method: 'get',
        params: {
          index: this.commentIndex,
          liveId: liveId,
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          if (!data.data) {
            this.commentNone = true
            return this
          }
          if (data.data.length) {
            localStorage.setItem(
              'commentLists_' + liveId,
              JSON.stringify(data.data)
            )
            this.commentLists = this.commentLists.concat(data.data)
            console.log(this.commentLists)
          }
        } else {
          this.commentIndex = 0
          this.commentLists = []
        }
      })
    },
    loadMoreComment() {
      this.commentIndex = this.commentIndex + 10
      this.getAllComments(this.liveId)
    },
    //获取历史提问
    getAllQuestions(liveId) {
      this.$http({
        url: `/live/livequestioninfor/getQuestionsByPage`,
        method: 'get',
        params: {
          liveId: liveId,
          index: this.questionIndex,
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          if (!data.data) {
            this.questionNone = true
            return this
          }
          if (data.data.length) {
            localStorage.setItem(
              'questList_' + liveId,
              JSON.stringify(data.data)
            )
            this.questList = this.questList.concat(data.data)
          }
        } else {
          this.questionIndex = 0
          this.this.questList = []
        }
      })
    },
    loadMoreQuestion() {
      this.questionIndex = this.questionIndex + 10
      this.getAllQuestions(this.liveId)
    },
    initWebSocket() {
      if (timer) {
        clearInterval(timer)
      }
      // 初始化weosocket
      let obj = {}
      obj.id = this.userInfo ? this.userInfo.userId : ''
      obj.liveId = this.liveId
      obj.status = this.live.liveStatus
      obj.token = '123456'
      console.log(obj)
      const wsuri =
        this.$wxBaseURL + '?request=' + Base64.encode(JSON.stringify(obj))
      this.websock = new ReconnectingWebSocket(wsuri)
      this.websock.onmessage = this.websocketonmessage
      this.websock.onopen = this.websocketonopen
      this.websock.onerror = this.websocketonerror
      this.websock.onclose = this.websocketclose
    },
    websocketonopen(e) {
      // 连接建立之后执行send方法发送数据
      console.log('Connection open ...')
      this.openInvake(e)
    },

    websocketonerror() {
      // 连接建立失败重连
      this.initWebSocket()
    },
    websocketonmessage(e) {
      // 数据接收
      console.log('数据接收' + e)
      let _this = this
      const redata = JSON.parse(e.data)
      var data = eval('(' + e.data + ')')
      console.log('onmessage data: ' + JSON.stringify(data))
      switch (data.uri) {
        case (1 << 8) | 220: // ping message
        case (2 << 8) | 220: // pong message
          console.log('ping message: ' + JSON.stringify(data))
          _this.pingInvake(data)
          break
        case (3 << 8) | 220: // system message
          _this.sysInvake(data)
          break
        case (4 << 8) | 220: // error message
          console.log('error message: ' + JSON.stringify(data))
          _this.closeInvake(null)
          break
        case (5 << 8) | 220: // auth message
          console.log('auth message: ' + JSON.stringify(data))
          break
        case (6 << 8) | 220: // broadcast message   //评论消息
          window.pageYOffset = 0
          document.documentElement.scrollTop = 0
          document.body.scrollTop = 0
          _this.broadcastInvake(data)
          break
        case (7 << 8) | 220: // 提问消息
          window.pageYOffset = 0
          document.documentElement.scrollTop = 0
          document.body.scrollTop = 0
          _this.broadcastInvake(data)
          break
      }
    },
    websocketclose(e) {
      // 关闭
      console.log('断开连接', e)
      // this.closeInvake(e)
    },
    send(auth, mess) {
      //发送消息的时候触发
      if (!window.WebSocket || !this.websock) {
        return
      }
      if (this.websock.readyState == WebSocket.OPEN || auth) {
        console.log('send: ' + mess)
        this.websock.send(mess)
      } else {
        console.log('连接没有成功，请重新登录')
      }
    },
    openInvake(e) {
      // let obj = {}
      // obj.code = 10000
      // obj.nick = this.userInfo ? this.userInfo.nickName : ''
      // obj.userId = this.userInfo ? this.userInfo.userId : ''
      // obj.liveId = this.liveId
      // obj.liveStatus = this.live.liveStatus
      // this.send(true, JSON.stringify(obj))
      timer = setInterval(() => {
        this.pingInvake()
      }, 40000)
    },
    closeInvake(e) {
      this.websock = null
      this.isAuth = false
      console.log('登录失败，网络连接异常')
    },
    sysInvake(data) {
      switch (data.extend.code) {
        case 20001: // user count
          console.log('current user: ' + data.extend.mess)
          if (this.live.liveStatus === 2) {
            this.tim = data.extend.mess
            if (!this.tims) {
              this.total =
                parseInt(this.tim) + parseInt(this.live.liveAttr.lookNum)
            } else {
              this.total = parseInt(this.tim) + parseInt(this.tims)
            }

            console.log(this.total)
          } else {
            const current = data.extend.mess.split('_')
            this.current.total = current[0]
            this.current.times = current[1]
          }
          // const current = data.extend.mess.split('_')
          // this.current.total = current[0]
          // this.current.times = current[1]
          break
        case 20002: // auth
          console.log('auth result: ' + data.extend.mess)
          this.isAuth = data.extend.mess
          if (this.isAuth) {
            console.log('欢迎来到HF聊天室！')
          }
          break
        case 20003: // system message
          console.log('system message: ' + data.extend.mess)
          break
        case 20004: // system message
          this.tims = data.extend.mess
          this.total = parseInt(this.tim) + parseInt(this.tims)
          break
      }
    },
    broadcastInvake(data) {
      console.log('我是广播消息:')
      let obj = JSON.parse(data.body)
      if (data.uri === 1756) {
        obj.content = obj.msg
        obj.avatar = obj.icon
        this.commentLists.unshift(obj)
        localStorage.setItem(
          'commentLists_' + this.liveId,
          JSON.stringify(this.commentLists)
        )
      } else if (data.uri === 2012) {
        obj.avatar = obj.icon
        obj.queContent = obj.content
        this.questList.unshift(obj)
        localStorage.setItem(
          'questList_' + this.liveId,
          JSON.stringify(this.questList)
        )
      }
    },
    pingInvake(data) {
      //发送pong消息响应
      this.send(this.isAuth, "{'code':10016}")
    },
    //发表评论
    addComments(comment) {
      // 判断评论是否为空
      if (comment === '') {
        this.$toast({
          message: '评论内容不能为空',
          position: 'bottom',
          duration: 1500,
        })
        return
      }
      // 判断评论是否包含关键词
      this.$http({
        url: '/live/commentsKeywords/listKeys',
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 0) {
          const kws = data.data.split(',')
          const i = comment.search(new RegExp(kws.join('|')))
          if (i != -1) {
            this.$toast({
              message: '包含敏感词，禁止发送',
              position: 'bottom',
              duration: 1500,
            })
            return this
          }
          this.state = 0
          let obj = {}
          obj.code = 10086
          obj.nick = this.userInfo ? this.userInfo.nickName : ''
          obj.liveId = this.liveId
          obj.userId = this.userInfo ? this.userInfo.userId : ''
          obj.icon = this.userInfo
            ? this.userInfo.avatar
            : require('../../../assets/img/timg.jpg')
          obj.state = this.state
          obj.liveStatus = this.live.liveStatus
          obj.msg = comment
          this.send(true, JSON.stringify(obj))
          this.comment = ''
        }
      })
    },
    // 发布提问
    addQuestion(askText) {
      // 判断提问是否为空
      if (askText === '') {
        this.$toast({
          message: '请输入提问内容',
          position: 'bottom',
          duration: 1500,
        })
        return this
      }
      if (!this.teacher) {
        this.$toast({
          message: '请选择要提问的老师',
          position: 'bottom',
          duration: 1500,
        })
        return this
      }
      // 判断提问是否包含关键字
      this.$http({
        url: '/live/commentsKeywords/listKeys',
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 0) {
          const kws = data.data.split(',')
          const i = askText.search(new RegExp(kws.join('|')))
          if (i != -1) {
            this.$toast({
              message: '包含敏感词，禁止发送',
              position: 'bottom',
              duration: 1500,
            })
            return this
          }

          this.state = 1
          let obj = {}
          obj.code = 10086
          obj.nick = this.userInfo ? this.userInfo.nickName : ''
          obj.liveId = this.liveId
          obj.userId = this.userInfo ? this.userInfo.userId : ''
          obj.icon = this.userInfo
            ? this.userInfo.avatar
            : require('../../../assets/img/timg.jpg')
          obj.state = this.state
          obj.content = this.teacher + ' ' + askText
          obj.lecturer = this.teacher
          obj.liveStatus = this.live.liveStatus
          this.send(true, JSON.stringify(obj))
          this.askText = ''
          this.teacher = ''
        }
      })
    },
    // 获取直播列表，提取讲师列表
    getLiveList() {
      let _this = this
      _this
        .$http({
          url: `/live/live/info/${this.liveId}`,
          method: 'get',
        })
        .then(({ data }) => {
          //0 重置播放器
          _this.$refs.videoPlayer.player.reset()

          if (data && data.code === 0) {
            _this
              .$http({
                url: `/live/topicLive/saveTopicLive`,
                method: 'post',
                params: {
                  userId: this.userInfo.userId,
                  liveId: this.liveId,
                },
              })
              .then(({ data }) => { })
            const Data = data.data
            _this.live = Data

            if (_this.live.liveAttr) {
              _this.live.liveAttr = JSON.parse(_this.live.liveAttr)
            }

            _this.live.liveStartTime = _this.live.liveStartTime.substring(0, 19)
            _this.live.liveEndTime = _this.live.liveEndTime.substring(11, 19)
            _this.dataSlots[0].values = _this.live.liveLecturers.split(',')
            _this.teachers = _this.live.liveLecturers.split(',')
            if (Data.liveStatus === 0) {
              _this.$toast('该直播暂未开始，不能观看')
              _this.$router.go(-1)
              return
            }
            if (Data.liveStatus === 1 || Data.liveStatus === 2) {
              _this.isliving = false
              _this.initWebSocket()
            }
            var arr = []
            if (Data.liveStatus === 1) {
              arr = []
            } else {
              arr = [0.5, 1.0, 1.25, 1.5, 1.75, 2.0]
            }
            _this.playerOptions = {
              //播放速度
              playbackRates: arr,
              //如果true,浏览器准备好时开始回放。
              autoplay: false,
              // 默认情况下将会消除任何音频。
              muted: false,
              // 导致视频一结束就重新开始。
              loop: false,
              // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
              preload: 'auto',
              language: 'zh-CN',
              // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
              aspectRatio: '16:9',
              // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
              fluid: true,
              sources: [
                {
                  //类型
                  type:
                    Data.liveStatus === 2
                      ? 'video/mp4'
                      : 'application/x-mpegURL',
                  //url地址
                  src:
                    Data.liveStatus === 2
                      ? Data.adapter.adpHistoryUrl
                      : Data.adapter.adpPlayUrl,
                },
              ],
              //你的封面地址
              poster: Data.liveCoverImg,
              //允许覆盖Video.js无法播放媒体源时显示的默认信息。
              notSupportedMessage: '此视频暂无法播放，请稍后再试',
              controlBar: {
                timeDivider: true,
                durationDisplay: true,
                remainingTimeDisplay: false,
                //全屏按钮
                fullscreenToggle: true,
              },
            }
          }
        })
    },
    // @老师
    askTeacher(teacher) {
      this.cerSpecialityShow = false
      // this.teacher = teacher
      // this.askText = '@' + teacher + ' '
      // this.teacherListShow = 'none'
    },
    getComment(score) {
      this.commentText += score
    },
  },
}
</script>

<style lang='scss' scoped>
.showPopup {
  text-align: right;
  margin-right: 1rem;
  padding: 1rem 0;
  font-size: 18px;
}

/deep/ .mint-popup-bottom {
  width: 100%;
}

.info {
  img {
    width: 40px;
    display: inline-block;
    //     margin-right: 10px;
  }

  padding: 1rem;
  padding-bottom: 0;
  background-color: #fff;

  .col-red {
    color: #666;
    font-size: 12px;
  }

  p {
    // margin: 10px 0;
    // margin-bottom: 0;
    font-size: $font-title2;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  span {
    margin-right: 10px;
    margin-left: 5px;
    font-size: 18px;
    font-style: oblique;
  }
}

.current-size {
  text-align: right;

  span {
    font-size: 12px;

    font-style: normal;
  }

  .yell {
    color: $theme-color;
  }
}

/deep/ .mint-tab-item {
  padding: 10px 0;
}

.current {
  text-align: right;
  color: #fff;

  span {
    background-color: $theme-color;
    border-radius: 10px;
    padding: 2px 5px;
    font-size: 12px;
    color: #fff;
    font-style: normal;
  }
}

.top_fixed {
  width: 100%;
}

.questions-list {
  margin-top: 12px;
  margin-bottom: 7rem;
  padding: 0 10px;

  .questions-list-item {
    margin-bottom: 20px;

    .questions-list-item-heading {
      display: inline-block;

      img {
        height: 32px;
        width: 32px;
        border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
      }

      .questions-list-item-username {
        margin-left: 5px;
        font-weight: bold;
      }
    }

    .comments-list-item-content {
      margin: 10px 0px;
      border-bottom: 1px solid #cccccc;

      &:last-child {
        border-bottom: 0;
      }

      span {
        vertical-align: top;
      }
    }

    .questions-list-item-content {
      padding: 4px 0 0 37px;
      word-break: break-all;
    }
  }
}

ul {
  background-color: #eee;
  padding: 1rem;

  li {
    text-align-last: center;
    margin: 1rem;
    color: #666;
  }
}

.timg {
  text-align: center;
  padding-top: 10%;
  padding-bottom: 40px;

  img {
    width: 60%;
    display: inline-block;
  }
}

.videoContext {
  width: 100%;
  position: relative;

  // padding: 30px 0;
  .hide-notice {
    display: none;
  }
}

.notice-card-wrapper {
  position: absolute;
  top: 0;
  z-index: 999999999999999;
  width: 95%;

  .inner-container {
    // margin-left: 100%; // 把文字弄出可见区域
    // width: 200%;
    // animation: myMove 15s linear infinite; // 重点，定义动画
    // animation-fill-mode: forwards;
    color: $theme-color;
  }

  /*文字无缝滚动*/
  // @keyframes myMove {
  //   0% {
  //     transform: translateX(0);
  //   }
  //   100% {
  //     transform: translateX(-100%);
  //   }
  // }
}

/deep/ .mint-cell-wrapper,
/deep/ .mint-field-core {
  background-color: #eee;
}

.input_footer {
  max-width: 760px;
  background-color: #eee;
  padding: 5px;
  position: fixed;
  bottom: 0;
  z-index: 1000;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.noteBottom {
  background-color: #fff;
  // width: 75%;
  padding-left: 5px;

  input {
    outline: none;
    border: 0;
    margin: 5px 0;
    padding-left: 5px;
    height: 30px;
  }

  a {
    font-size: 14px;
    padding-right: 10px;
    // background-color: #eee;
  }
}

.score {
  p {
    margin-left: 1rem;
  }

  .star {
    text-align: center;

    img {
      margin: 2rem 1rem 1rem 0;
      align-self: center;
    }

    button {
      margin: 2rem 2rem 0 0;
      padding: 1rem;
      border-radius: 2rem;
      height: 4rem;
      background-color: $theme-color;
      border: none;
      color: #333;
    }
  }

  /deep/ .mint-cell-wrapper {
    width: 100%;
  }
}

.barrages-drop {
  .blue {
    border-radius: 100px;
    background: #e6ff75;
    color: #fff;
  }

  .green {
    border-radius: 100px;
    background: #75ffcd;
    color: #fff;
  }

  .red {
    border-radius: 100px;
    background: #e68fba;
    color: #fff;
  }

  .yellow {
    border-radius: 100px;
    background: #dfc795;
    color: #fff;
  }

  .baberrage-stage {
    position: absolute;
    width: 100%;
    height: 212px;
    overflow: hidden;
    top: 0;
    margin-top: 130px;
  }
}

.footer-comment {
  width: 95%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 1000;
  padding-left: 2rem;
  box-sizing: border-box;
  padding-bottom: 1rem;
  background-color: #fff;

  .foot-box {
    display: flex;
    align-items: center;
    /*position: relative;*/
    justify-content: space-between;
    padding: 0 1rem 0 0;
    background-color: #fff;
    width: 100%;
    box-sizing: border-box;

    /deep/ .mint-cell {
      width: 70%;
      border-radius: 6px;
    }
  }
}

.comment-send-btn {
  width: 70px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  border: none;
  border-radius: 1rem;
  box-sizing: border-box;
  font-weight: bold;
  font-size: 13px;
  color: #ffffff;
  background-color: $theme-color;

  &:hover {
    cursor: pointer;
  }
}

.columns {
  margin: 1rem;
  font-size: 18px;

  // font-weight: bold;
  img {
    display: inline-block;
    width: 20px;
    margin-bottom: 5px;
    margin-right: 10px;
    border-radius: 5px;
  }
}

.p-title {
  margin: 1rem 0;
  // font-weight: bold;
}

.p-desc {
  color: #333;
  font-size: 14px;
  line-height: 30px;
  text-indent: 2em;
  margin-top: 1rem;
}

::v-deep img {
  width: 100%;
  display: block;
}

.video-btn {
  color: #009688;
  float: right;
}

.disableClass {
  opacity: 0.6;
}

/deep/ .vjs-poster {
  background-size: cover;
}
</style>
